import { useQuery } from '@tanstack/react-query';
import { newAccountCheckService } from 'services/new-account-check/new-account-check.service';
import { queryClient } from 'ui/components/AppProvider/AppProvider';

export const getIsNewAccount = () => {
  return queryClient.ensureQueryData({
    queryKey: ['newAccountCheckService.checkNewAccount'],
    queryFn: newAccountCheckService.checkNewAccount,
  });
};

export function useIsNewAccount() {
  return useQuery({
    queryKey: ['newAccountCheckService.checkNewAccount'],
    queryFn: newAccountCheckService.checkNewAccount,
  });
}
